import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, HomeIcon, BotIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const steps = [{
  icon: ZapIcon,
  title: 'Téléchargez instantanément',
  text: 'Finalisez votre achat et accédez immédiatement aux plus de 100 guides PDF pas à pas — sans attente ni livraison.',
  tone: 'bg-sky-light text-sky',
  numberTone: 'bg-sky'
}, {
  icon: HomeIcon,
  title: 'Rassemblez des matériaux simples',
  text: 'Chaque projet utilise des objets du quotidien que vous avez déjà chez vous — carton, ruban adhésif, élastiques et bouchons. Aucun achat spécial nécessaire.',
  tone: 'bg-sunshine-light text-ink',
  numberTone: 'bg-sunshine text-ink'
}, {
  icon: BotIcon,
  title: 'Construisez et apprenez ensemble',
  text: 'Suivez le guide illustré avec votre enfant et regardez-le créer de vrais robots fonctionnels — avec une immense fierté.',
  tone: 'bg-coral-light text-coral',
  numberTone: 'bg-coral text-ink'
}];
export function HowItWorks() {
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-96" data-mp="2mml4ippq255q">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-97" data-mp="2mo5z2fc1do3l">
        <SectionHeading eyebrow="Comment ça marche" title={<>Du téléchargement au premier robot en 3 étapes simples</>} subtitle="Aucune connaissance technique, aucun outil spécial ni matériel coûteux. Téléchargez, rassemblez quelques objets de la maison et lancez-vous." data-id="element-98" data-mp="31b7kmtn6b0y0" />
        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-99" data-mp="36bbzkf8fnnm4">
          {steps.map((s, i) => <motion.div key={s.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="relative rounded-3xl border border-ink/10 bg-white p-8" data-id="element-100" data-mp="3kav6x5tf6uxd" data-mpi={i}>
              <span className={`absolute -top-4 left-8 flex h-9 w-9 items-center justify-center rounded-full font-display text-lg font-bold ${s.numberTone}`} data-id="element-101" data-mp="3pytsgm3oa5b2">
                {i + 1}
              </span>
              <span className={`flex h-14 w-14 items-center justify-center rounded-2xl ${s.tone}`} data-id="element-102" data-mp="2rrexd34066u">
                <s.icon className="h-7 w-7" aria-hidden="true" data-id="element-103" data-mp="7qun36edysj1" />
              </span>
              <h3 className="mt-5 font-display text-xl font-bold text-ink" data-id="element-104" data-mp="cqgvn2j9rkli">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-105" data-mp="hl4diijrpgr4">
                {s.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}